<template lang="pug">
  .engine-details(v-if="rows.length")
    .engine-details__row(v-for="row in rows" :key="row.key")
      span.engine-details__label {{ row.label }}
      span.engine-details__value {{ row.value }}
</template>

<script>
/**
 * @component ValidationEngineDetails
 * @description Lista label/valor con el detalle del afiliado que devuelve el
 * motor de elegibilidad externo, dentro de los banners del validador. No
 * conoce ningún motor: recibe filas ya formateadas de `getValidationDetails`
 * y no renderiza nada si no hay.
 */
export default {
  name: "ValidationEngineDetails",
  props: {
    /** @type {Array<{key: string, label: string, value: string}>} */
    rows: { type: Array, default: () => [] },
  },
};
</script>

<style lang="scss" scoped>
.engine-details {
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.04);
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 12px;
  &__row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 2px 0;
  }
  &__label {
    color: #6b7294;
  }
  &__value {
    font-weight: 600;
    text-align: right;
  }
}
</style>
